import { contentByPath } from "./content";
import { Layout } from "./components/Layout";
import { normalizePath } from "./lib/routes";
import { ArticlePage } from "./pages/ArticlePage";
import { ArticlesPage } from "./pages/ArticlesPage";
import { ConsultationPage } from "./pages/ConsultationPage";
import { HelpPage } from "./pages/HelpPage";
import { HomePage } from "./pages/HomePage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { StandardPage } from "./pages/StandardPage";

type AppProps = { path: string };

export function App({ path }: AppProps) {
  const normalizedPath = normalizePath(path);
  const content = contentByPath(normalizedPath);
  let page: React.ReactNode;

  if (normalizedPath === "/") page = <HomePage />;
  else if (normalizedPath === "/articles/") page = <ArticlesPage />;
  else if (normalizedPath === "/consultation/") page = <ConsultationPage />;
  else if (normalizedPath === "/privacy/") page = <PrivacyPage />;
  else if (content?.type === "post") page = <ArticlePage article={content} />;
  else if (content?.slug === "help") page = <HelpPage page={content} />;
  else if (content) page = <StandardPage page={content} />;
  else page = <NotFoundPage />;

  return <Layout>{page}</Layout>;
}
